import React, { useRef } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import MessageBubble from './MessageBubble';
import TypingIndicator from './TypingIndicator';

function MessageList({ messages, isTyping, userPhoto, messagesEndRef }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const chatContainerRef = useRef(null);

  return (
    <Box
      ref={chatContainerRef}
      sx={{
        flexGrow: 1,
        overflowY: 'auto',
        p: isMobile ? 1 : 2,
        display: 'flex',
        flexDirection: 'column',
        gap: isMobile ? 2 : 3,
        minHeight: 0,
        flex: isMobile ? '1 1 0' : '1 1 auto',
        bgcolor:
          theme.palette.mode === 'dark'
            ? 'rgba(0,0,0,0.2)'
            : 'rgba(0,0,0,0.02)',
      }}
    >
      {messages.map((message) => (
        <MessageBubble
          key={message.id}
          isTyping={isTyping}
          message={message}
          userPhoto={userPhoto}
        />
      ))}
      {/* {isTyping && <TypingIndicator userPhoto={userPhoto} />} */}
      <div ref={messagesEndRef} />
    </Box>
  );
}

export default MessageList;
